var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { css } from '@emotion/react';
import { Colors, Spacer, VisuallyHidden, ZapierLogo, } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { skipLinkHref, topNavFallbackData, UNIVERSAL_TOPBAR_CONDENSED_HEIGHT, UNIVERSAL_TOPBAR_HEIGHT, } from '../../constants';
import { useUniversalNavContext } from '../../hooks';
import SkipLink from '../SkipLink';
import { staticProductTabBottomLinks } from '../UniversalTopbar/UniversalTopbar';
import UniversalTopbarLink from '../UniversalTopbar/UniversalTopbarLink';
import AccountActions from '../UniversalTopbar/AccountActions';
import SearchForm from '../UniversalTopbar/SearchForm';
const Styles = labelStyles('TopbarLoadingState', {
    root: [
        {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: `${Colors.neutral100}`,
            position: 'relative',
            borderBottom: `1px solid ${Colors.neutral300}`,
        },
    ],
    header: css({
        width: '100%',
        maxWidth: '1200px',
        height: UNIVERSAL_TOPBAR_CONDENSED_HEIGHT,
        padding: '0 10px 0 59px',
        display: 'grid',
        gridTemplateColumns: 'max-content auto max-content',
        alignItems: 'stretch',
        gap: '5px',
        backgroundColor: Colors.neutral100,
        '@media (min-width: 450px)': {
            height: UNIVERSAL_TOPBAR_HEIGHT,
            padding: '0 20px 0 71px',
            gap: '0',
        },
        '@media (min-width: 1040px)': {
            paddingLeft: '20px',
        },
    }),
    group: css({
        display: 'grid',
        gridAutoFlow: 'column',
        alignItems: 'center',
        justifySelf: 'flex-end',
        gap: '5px',
        '@media (min-width: 450px)': {
            gap: '17px',
        },
    }),
    mainNavigationContent: [
        {
            display: 'flex',
            alignItems: 'stretch',
            marginLeft: 25,
        },
    ],
    logoLinksWrapper: {
        position: 'relative',
    },
    skipLink: {
        position: 'absolute',
        top: '100%',
        whiteSpace: 'nowrap',
    },
});
const TopbarLoadingState = (_a) => {
    var _b;
    var { shouldRenderHiddenMenu = true } = _a, props = __rest(_a, ["shouldRenderHiddenMenu"]);
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const logoSize = {
        width: 105,
        height: 28,
    };
    return (isolateComponent("div", { css: Styles.root },
        isolateComponent("div", { css: Styles.header, "data-testid": "universalTopbar-loading-state" },
            isolateComponent("div", { css: Styles.group }, props.shouldRenderLogo && (isolateComponent("header", { css: Styles.logoLinksWrapper },
                isolateComponent("a", { "aria-label": props.logoAriaLabel, href: getFullyQualifiedURL(props.logoHref), onClick: props.onLogoClick },
                    isolateComponent(ZapierLogo, Object.assign({}, logoSize))),
                isolateComponent("div", { css: Styles.skipLink },
                    isolateComponent(SkipLink, { href: props.skipLinkHref }))))),
            isolateComponent("div", { css: Styles.mainNavigationContent }, shouldRenderHiddenMenu ? (isolateComponent(VisuallyHidden, null,
                isolateComponent("nav", { "aria-label": "Site Links", id: "site-nav" },
                    isolateComponent("ul", null,
                        isolateComponent(UniversalTopbarLink, { ariaControls: "Product", bottomLinks: staticProductTabBottomLinks, href: null, isSelected: false, isStaticProductTab: true, key: "Product", submenu: [] }, "Product"), (_b = topNavFallbackData === null || topNavFallbackData === void 0 ? void 0 : topNavFallbackData.topBarMenu) === null || _b === void 0 ? void 0 :
                        _b.map((link) => (isolateComponent(UniversalTopbarLink, { href: link.href, key: link.text, isSelected: false, submenu: link.submenu }, link.text))))))) : (isolateComponent(Spacer, null))),
            isolateComponent("div", { "aria-label": "Manage your account and search apps", css: Styles.group, role: "form" }, props.renderAccountMenu(props)))));
};
TopbarLoadingState.defaultProps = {
    logoAriaLabel: 'Go to the Zapier Homepage',
    logoHref: '/',
    onLogoClick: () => { },
    renderAccountMenu: (props) => (isolateComponent(AccountActions, { selectedHref: props.selectedHref, shouldRenderSignIn: props.size !== 'small', shouldRenderSignUp: true, size: props.size })),
    renderNotifications: () => null,
    renderSearchForm: (props) => (isolateComponent(SearchForm, { isSearching: props.isSearching, onClose: props.onClose, searchInputId: props.searchInputId })),
    selectedHref: '',
    shouldRenderLogo: true,
    size: 'medium',
    skipLinkHref,
};
export default TopbarLoadingState;
//# sourceMappingURL=TopbarLoadingState.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)
